// Portuguese
export const locale = {
  lang: "pt",
  data: {
    TRANSLATOR: {
      SELECT: "Select your language",
    },
    MENU: {
      MEETINGS: "MEETINGS",
      CARS: "Carros",
      ADMINISTRADOR: "ADMINISTRADOR",
      NEW: "Nova",
      ACTIONS: "Ação",
      CREATE_POST: "Create New Post",
      PAGES: "Página",
      FEATURES: "Características",
      APPS: "Apps",
      CALENDAR: "Calendário",
      ROOMS: "Salas",
      SPACE: "Plantas",
      REPORT: "Reportar Avarias",
      DASHBOARD: "Painel de Controlo",
      USERSETTINGS: "Definições de Utilizador",
      SYSTEMSETTINGS: "Definições do Sistema",
      LOGOCONFIGURATION: "Configuração do Logotipo",
      EMAILCONFIGURATION: "Configuração de Email",
      EQUIPMENTS: "Equipamentos",
      STYLESETTINGS: "Configurações de estilo",
      CONFIGURATIONBYLOCATION: "Configuração por Localização ",
      ROOMSETTINGS: "Definições dos Recursos",
      ACCOUNTINFORMATION: "Informações de Conta",
      BOOKING: "Reserva",
      CHECKOUTS: "Checkouts",
      NOCHECKOUTS:"Sem Check-Out",
      VISITORS: "Visitantes",
      VISITS: "Visitas",
      CONFIGURECUSTOMERADMIN: "Configurar Admin do Cliente",
      MRROOM: "Quartos do senhor",
      ADMMINBACKOFFICE: "Admin Back Office",
      ADMIN: "Administrador",
      MRVISITS: "Sr. Visitas",
      USERS: "Utilizadores",
      ROLLSETTINGS: "Definições das Funções",
      ACCESSRIGHTS: "Permissões",
      VisitsSettings: "Configurações das Visitantes",
      ORDERS:"Encomendas",
      ORDERPENDING:"Encomendas Pendentes",
      LICENSEDASHBOARD: 'License Dashboard'
    },
    ROOMS: {
      SUNDAY: "Dom",
      MONDAY: "Seg",
      TUESDAY: "ter",
      WEDNESDAY: "qua",
      THURSDAY: "qui",
      FRIDAY: "sex",
      SATURDAY: "sáb",
      LOCATION: "Localização",
      ROOMS: "Salas",
      EQUIPMENTS: "Equipamentos",
      STARTDATE: "Data de Início ",
      ENDDATE: "Data de Fim",
      STARTTIME: "Hora do Início",
      ENDTIME: "Hora do Fim",
      TIMEDURATION: "Duração",
      ALL: "Todos",
      MEETINGROOM: "Sala de Reuniões",
      DESK: "Mesa",
      CAR: "Carros",
      SERVICE: "Serviço",
      PLANT: "Planta",
      BOOK: "Marcar",
      SERVICES: "Serviços",
      CATERING: "Catering",
      ITSUPPORT: "Suporte Informático ",
      MOBILEEQUIPMENT: "Equipamentos Móveis",
      SPECIAL: "Especial",
      COMMINGSOON: "Em breve",
      MAPPLANT: "Planta",
      ROOMBOOKING: " Reserva de quarto",
      LOCATIONS: "Localização ",
      RESOURCES: "Recursos",
      REQUESTERNAME: "Nome do solicitante",
      SUBJECT: "Sujeito",
      DESCRIPTION: "Descrição",
      ADDUSER: "Adicionar Utilizador",
      ADDVISITORS: "Adicionar Visitantes",
      EDITVISITORS:"Editar Visitantes",
      CATERINGDESCRIPTION: "Descrição do Catering ",
      MOBILEEQUIPMENTDESCRIPTION: "Descrição dos Equipamentos Móveis",
      ITSUPPORTDESCRIPTION: "Descrição do Suporte Informático",
      SPECIALSERVICE: "Serviço Especial ",
      SPECIALSERVICEDESCRIPTION: "Descrição dos Serviços Especiais",
      REQUESTEREMAIL: "Email do solicitante",
      SUMMARY: "Sumário",
      TOTALBOOKINGS: "Total de Marcações ",
      TOTALMINUTES: "Total de Minutos",
      USERS: "Utilizadores",
      AVERAGEBOOKINGSTIMES: "Tempo Médio de Marcação",
      ROOM: "Salas",
      DESKS: "Mesas",
      CARS: "Carros",
      PARKINGSEATS: "Lugares de Estacionamento",
      AVILABLE: "Disponível",
      FULL: "Ocupado",
      ROOMUSAGE: "Utilização das Salas",
      CARUSAGE: "Utilização dos Carros",
      DESKUSAGE: "Utilização das Mesas",
      NUMBEROFBOOKINGSPERROOM: "Número de Marcações por Sala",
      NUMBEROFMINTUESPERROOM: "Número de Minutos por Sala",
      NUMBEROFMINTUESPERDESK: "Número de Marcações por Mesa",
      PARKINGSPACEUSAGE: "Utilização dos Lugares de Estacionamento",
      USER: "Utilizadores",
      NUMBEROFBOOKINGSPERPARKINGSEATS:
        "Número de Marcações por Lugares de Estacionamento",
      NAME: "Nome",
      BOOKINGS: "Marcações",
      MINTUES: "Minutos",
      ATTENDED: "Participou",
      CANCEL: "Cancelar",
      NUMBEROFMINTESPERPARKINGSEATS:
        "Número de Minutos por Lugar de Estacionamento",
      CHECKIN: "Check-In",
      TYPEOFBOOKING: "Tipo de Marcação",
      MEETINGBEHAVIOR: "Comportamento das Marcações",
      USERTHATMISSEDCHECKIN: "Utilizadores que falharam o check-in",
      ENDEDASPLANING: "Terminaram como planeado",
      ENDEDONLY: "Terminaram mais cedo",
      CANCELED: "Cancelar",
      TOTAL: "Total",
      ACTIVE: "Ativas ",
    },
    ROOMBOOKING: {
      EXTENDTIMEDURATION: "Extender Duração",
      MINUTE: "Minutos",
      PINCODE: " Código PIN",
      NEWBOOKING: "Nova Marcação",
      LOCATIONS: "Localização",
      BUILDING: "Edifício",
      FLOOR: "Piso",
      RESOURCES: "Recursos",
      STARTDATE: "Data de Início",
      ENDDATE: "Data de Fim",
      STARTTIME: "Hora de Início",
      ENDTIME: "Hora de Fim",
      TIMEDURATION: "Duração",
      SELECTLOCATION: "Selecione uma localização",
      SELECTBUILDING: "Selecione Edificio",
      SELECTFLOOR: "Selecione Piso",
      SELCETRESOURCE: "Selecione um Recurso",
      SELECTTIMEDURATION: "Selecione a duração",
      TIMEDURATIONREQUIRED: "Tempo de Duração é Obrigatório",
      SELECTCAR: "Selecione uma Carro",
      CARREQUIRED: "Carro é obrigatório",

      SELECTYOURROOM: "Selecione uma Sala",
      SELECTYOURDESK: "Selecione uma Mesa",
      ROOMREQUIRED: " Sala é obrigatório",
      DESKREQUIRED: " Mesa é obrigatória",
      CHARGINGCARREQUIRED: "Charging Car is required",
      PARKINGSEATREQUIRED: "Lugares de Estacionamento  é obrigatório",

      RESOURCETYPEREQUIRED: "Recursos é obrigatório",
      REQUESTOREMAILREQUIRED: "Email do Requisitante é obrigatório",
      REQUESTORNAMEREQUIRED: "Requisitante Nome é obrigatório",
      DESKS: "Mesas",
      REQUESTORNAME: "Requisitante",
      REQUESTOREMAIL: "Email do Requisitante",
      SUBJECT: "Assunto",
      BOOK: "Marcar",
      CAR: "Carro",
      CARS: "Carros",
      SUBJECTISREQUIRED: "Assunto é obrigatório",
      ADDUSERS: "Adicionar Utilizadores",
      ADDUSER: "Adicionar Utilizador",
      ADDVISITORS: "Adicionar visitantes",
      PARKINGSEATS: "Lugar de Estacionamento",
      CATERRING: "Catering",
      QUANTITY: "Quantidade",
      MOBILEEQUIPMENT: "Equipamentos Móveis ",
      ITSUPPORT: "Suporte Informático",
      CATERINGDESCRIPTION: "Catering Descrição",
      MOBILEEQUIPMENTDESCRIPTION: "Descrição dos Equipamentos Móveis ",
      ITSUPPORTDESCRIPTION: "Suporte Informático Descrição",
      SPECIALSERVICE: "Serviços Especiais",
      SPECIALSERVICEDESCRIPTION: "Descrição dos Serviços Especiais",
      CANCEL: "Cancelar",
      BACK: "Voltar",
      EQUIPMENT: "Equipamento",
      STARTDATEISREQUIRED: "Data de Início é obrigatória",
      ENDDATEISREQUIRED: "Data de Fim é obrigatória",
      STARTTIMEISREQUIRED: "Hora do Início de obrigatória",
      ENDTIMEISREQUIRED: "Hora do Fim é obrigatória",
      ROOMS: "Salas",
      DESCRIPTION: "Descrição",
      CLEANING: "Limpeza",
      CLEANINGDESCRIPTION: "Limpeza Descrição",
      CHECKROOMAVAILABLITY: "Verifique a disponibilidade da sala",
      EDITBOOKING: "Editar  Marcação ",
      EDIT: "Editar",
      DELETE: "Excluir",
      EXTEND: "Estender",
      END: "Fim",
      VIEWBOOKING: "Ver Marcação ",
      BOOKINGID: "Reserva ID",
      USERS: "Utilizadores",
      VISITORS: "Visitantes",
      CLOSE: "Fechar",

      COMPANY: "Empresa",
      VISITORNAME: "Nome da Visita",
      DRIVER: "Condutor ",
      LICENSEPLATE: "Matrícula",
      USAGETYPE: "Utilizador",
      ALLDAY: "Dia todo",
      CAPACITY: "Capacidade",

      EMPLOYEE: "Interno",
      VISIT: "Visita",
      CLIENT: "Cliente",
      SUPPLIER: "Fornecedor",
      COWORKER: "Interno temporário",
      CHECKOUT: "Checkout",
      DEBIT: "Débito",
      YES: "Sim",
      NO: "Não",
      CHARGINGCAR: "Posto de Carregamento",
      CHARGINGCARS: "Posto de Carregamento",
      CHARGINGCARUSAGE: "Posto de Carregamento",
      CHARGINGCARDURATION: "Duração Posto de Carregamento:",
      QUANTITYISREQUIRED: "Inserir quantidade",

      INVALIDSTARTTIME: "Hora de Início Inválida",
      INVALIDENDTIME: "Hora de Fim Inválida",
      AREYOUSUREYOUWANTTOACTIVATE: "Tem a certeza que pretende ativar?",
      AREYOUSUREYOUWANTTODEACTIVATE: "Tem a certeza que pretende desativar?",
      AREYOUSURE: "Tem certeza?",
      AREYOUSUREYOUWANTTODELETE: "Tem certeza de que deseja excluir?",
      ALLOWBOOKING: "Tem certeza Confirmar a reserva?",
      DENYBOOKING: "Tem a certeza de que quer rejeitar a reserva?",
      CREATEVISITOR: "Criar Visitante",
      ORDERMOBILEEQUIPMENT: "Pretende solicitar o equipamento"
      
    },

    DASHBOARD: {
      FROM: "de",
      TO: "a",
      NOWINUSE: "Ocupadas",
      FREEROOMS: "Salas gratuitas",
      FREEDESKS: "Mesas Livres",
      FREEPARKINGSEATS: "Lugar de estacionamento grátis",
      TODAY: "Hoje",
      RESERVATIONSOFROOMS: "Reserva de Salas",
      RESERVATIONSOFDESKS: "Reserva de Mesas",
      RESERVATIONSOFPARKINGSEATS: "Reserva de Lugares de estacionamento",
      USERSMISSEDCHECKIN: "Utilizadores que falharam o checkin",
      NORECENTCHECKIN: "Sem check ins recentes",
      CURRENTMONTH: "Mês corrente",
      RESERVATIONSPERROOM: "Reserva por sala",
      RESERVATIONSPERDESK: "Reserva por mesa",
      PARKINGSEATSRESERVATIONS: "Reserva de Lugares de estacionamento",
      RESERVATIONSPERUSER: "Reservas por usuário",
      MISSINGRESERVATIONS: "Reservas perdidas",
      TIMEOFRESERVATIONSPERUSER: "Tempo de reserva por utilizador",
      TIMEOFRESERVATIONSPERROOM: "Tempo de reserva por Sala",
      TIMEOFRESERVATIONSPERDESK: "Tempo de reserva por mesa",
      TOTALCOSTPERUSER: "Custo total por utilizador",
      DOWNLOADASCSVFILE: "Descarregar Ficheiro CSV",
    },

    USERSETTINGS: {
      UPLOADCSV: "Carregar CSV",
      IMPORTFROMLDAP: "Importar de LDAP",
      AZUREACTIVEDIRECTORY: "Azure active directory-AD",
      EDIT: "Editar",
      DELETE: "Apagar",
      BUILDINGSETTINGS: "Definições Edifício",
      SSO: "SSO",
      ADD: "Adicionar",
      NAME: "Nome",
      EMAIL: "Email",
      LOCATION: "Localização",
      ROLE: "Função",
      ACTION: "Ação",
      FILTER: "Filtro",
      CSVFILE: "Ficheiro CSV",
      DOWNLOADTEMPLATE: "Descarregar Template",
      UPLOAD: "Carregar ",
      LDAPSERVER: "Servidor LDAP",
      PORT: "Porta",
      DISABLETLS: "Desativar TLS",
      IMPORT: "Importar",
      CANCEL: "Cancelar",
      NODATAFOUND: "Sem dados disponíveis",
      USERNAME: "Nome de Utilizador",
      PASSWORD: "Senha",
      CHECKCONNECTION: "Verificar Conexão",
      LDAPSERVERBASE: "Base do servidor ldap",
      LDAPSEARCHFILTER: "Filtro de pesquisa LDAP",
      DEFAULTADUSERMAILBOX: "Filtro de caixa de correio de usuário AD padrão",
      CUSTOMLDAPFILTER: "Filtro LDAP personalizado",
      LDAPRFIDATTRIBUTE: "Atributo RFID LDAP (opcional)",
      COUNTRY: "País",
      ADDUSER: "Adicionar Utilizador",
      EDITUSER: "Editar Usuário",
      DELETEUSER: "Apagar Usuário",
      CLOSE: "Fechar",
      ADDROLES: "Adicionar Funções",
      ROLENAME: "Nome da Função",
      NAMEISREQUIRED: "Nome é obrigatório",
      ACCESSRIGHTS: "Permissões",
      SELECTALL: "Selecionar tudo",
      SELECTROLE: "-- Selecionar Função--",
      ROLEISREQUIRED: "Função é obrigatório",
      EDITUSERROLE: "Editar Função do Utilizador",
      DELETEUSERROLE: "Apagar Função de Usuário",
      SAVE: "Guardar",
      RESOURCERIGHTS: "Permissões Recursos",
      RESOURCEISREQUIRED: "Resource is required",
      SELECTALLMEETROOM: "Selecione Todas as Salas",
      SELECTALLDESK: "Selecione Todas as Mesas",
      SELECTALLPARKINGSEATS: "Selecione Todos os Lugares de Estacionamento",
      SELECTALLCHARGINGCAR: "Selecione Todos os Postos de Carregamento",
      SELECTALLCAR: "Selecione Todos os Carros",
    },

    USERACCESSRIGHTS: {
      CLOSE: "Fechar",
      EDITROLES: "Editar Função",
      BOOKABUILDING: "Reservar um Edifício",
      BOOKADESK: "Reservar uma Secretária",
      ORDERCATERING: "Pedir Catering",
      ENDABOOKING: "Terminar uma reserva",
      ACTIVATEINACTIVATE: "Ativar/Desativar Salas de Reunião",
      PARKINGCHECKOUT: "Check-out do estacionamento",
      ACTIVATEINACTIVATEDISPLAYS: "Ativar/Desativar Displays",
      BOOKAFLOOR: "Reservar um andar",
      BOOKAPARKINGSEATS: "Reservar um Lugar de Estacionamento",
      ORDERMOBILEEQUIPMENT: "Requisitar Equipamentos Móveis",
      DELETEABOOKING: "Apagar uma marcação",
      ACTIVATEINACTIVATEDESK: "Ativar/Desativar Secretatias",
      ACTIVATEINATIVATEKIOSKS: "Ativar/Desativar Kiosks",
      ORDERSPECIALSERVICES: "Requisitar serviços especiais",
      BOOKAROOM: "Reservar uma sala",
      ORDERITSERVICES: "Requisitar serviços de IT",
      EDITABOOKING: "Editar Reservas",
      EXTENDABOOKING: "Estender Reservas",
      ACTIVATEINACTIVATEPARKINGSEATS:
        "Ativar/Desativar Lugares de estacionamento",
      ACTICATEINACTICATEVIEWPOINTS: "Ativar/Desativar Viewpoints",
    },
    LOGOCONFIGURATION: {
      ENABLELOGOCHANGES: "Alterar Logotipo",
      UPLOADLOGO: "Carregar Logotipo",
      URL: "URL",
      OR: "(Ou)",
      SAVE: "Guardar",
    },
    EMAILCONFIGURATION: {
      EMAILCONFIGURATION: "Configuração de Email",
      EMAIL: "Email",
      PASSWORD: "Senha",
      HOSTSERVER: "Servidor ",
      PORT: "Porta",
      EMAILISREQUIRED: "Email é obrigatório",
      ENTERYOUREMAIL: "Introduzir Email",
      PASSWORDISREQUIRED: "Senha é obrigatório",
      ENTERYOURPASSWORD: "Introduzir Senha",
      ENTERPORT: "Introduzir a Porta",
      PORTISREQUIRED: "Porta é obrigatório",
      ENTERHOSTSERVER: "Introduzir o Host",
      HOSTSERVERREQUIRED: "Host Server é obrigatório",
      CHECKEMAIL: "Verificar Email",
      SAVE: "Guardar",
      TOEMAIL: "Para email",
    },

    STYLESETTINGS: {
      SYSTEMSTYLE: "Estilo do Sistema",
      SIDEBUTTONCOLOR: "Cor do botão lateral",
      ACTIONBUTTONCOLOR: "Cor do botão de ação",
      TOPTITLES: "Principais títulos",
      TEXTCOLOR: "Cor do texto",
      BACKGROUNDCOLOR: "Cor de fundo",
      KIOSKCHECKINSTYLE: "Estilo de check-in de quiosque",
      BACKGROUNDIMAGE: "Imagem de fundo",
      KIOSKINFORMATION: "Informações do quiosque",
      SERVICESVIEWPOINTSDISPLAYINFORMATION:
        "Informações de exibição de pontos de vista de serviços",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      RESTORETODEFAULT: "Restaurar para o padrão",
    },
    CONFIGURATIONBYLOCATION: {
      SEARCHHERE: "Procurar aqui…",
      COUNTRY: "País",
      LOCATION: "Localização",
      TIMEZONE: "Fuso Horário",
      ACTIONS: "Ação",
      ADDRESS: "Morada ",
      EDITLOCATIONTITLE: "Editar Localização",
      LOCATIONSETTINGSTITLE: "Definições Localização",
      ADDBUILDINGTITLE: "Edifício",
    },
    EQUIPMENTS: {
      EQUIPMENTALIGNMENT: "Lista de Equipamentos",
      SEARCHHERE: "Procurar",
      ICON: "Ícone",
      TITLE: "Título",
      ACTION: "Ação",
      LEFT: "Esquerda",
      RIGHT: "Direita ",
      TOP: "Topo",
      BOTTOM: "Baixo",
      ADD: "Adicionar",

      EDITEQUIPMENT: "Editar Equipamento",
      DELETEQUIPMENT: "Apagar Equipamento",
      EQUIPMENNAME: "Nome do Equipamento",
      SELECTEQUIPMENTICON: "Selecionar um ícone",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      REQUIREDFIELD: "Campo obrigatório",
      ADDNEWEQUIPMENT: "Adicionar Novo Equipamento",
      DELETE: "Apagar",
    },

    ACCOUTINFORMATION: {
      COMPANYNAME: "Nome da Empresa",
      CONTACTNAME: "Nome do Contacto",
      PHONENUMBER: "Número Telefónico",
      COUNTRY: "País",
      RESELLER: "Parceiro",
      EMAILTOREGISTRATION: "Email de Registo",
      TYPEOFACCOUNT: "Tipo de Conta",
      NUMBEROFROOMS: "Número de Salas",
      NUMBEROFROOMSDISPLAYS: "Número de Displays nas Salas ",
      NUMBEROFDESKS: "Número de Mesas ",
      NUMBEROFDESKSDISPLAYS: "Número de Displays nas Mesas ",
      NUMBEROFPARKINGSPACES: "Número de Lugares de Estacionamento",
      NUMBEROFSERVICESVIEWPOINTS: "Número de Viewpoints",
      NUMBEROFKIOSKS: "Número de Kiosks",
      NUMBEROFSPACE: "Número de Spaces",
      ACCOUNTID: "ID da Conta",
      VALIDFROM: "Válido de",
      VALIDTO: "Válido até",
      CONTACTSUPPORT: "Contactar o Suporte",
      MESSAGE: "Mensagem",
      CLOSE: "Fechar",
      SEND: "Enviar",
    },

    LOGINGPAGE: {
      WELCOMETOMRROOMS: "Bem-Vindo a Zelo Meetings",
      NEWHERE: "Novo aqui ?",
      DEMOACCOUNT: "Conta de Demonstração",
      ENTERYOURDETAILSTOCREATEYOURACCOUNT:
        "Insira seu e-mail para redefinir sua senha",
      COMPANYNAME: "Nome da Empresa",
      CONTACTNAME: "Nome do Contacto",
      PHONE: "Telefónico",
      COUNTRY: "País",
      CONFIRMPASSWORD: "Confirmar Palavra-passe",
      ACCEPTTERMSCONDITIONS: "Aceite os Termos e Condições",
      TERMSANDCONDITIONS: "Termos e Condições",
      EMAIL: "Email",
      PASSWORD: "Senha",
      FORGOTPASSWORD: "Esqueceu a senha?",
      DISCOVERAMAZINGWORKSPACE: "Discover Amazing Work Space",
      SERVICEVIEWPOINTS: "Viewpoints",
      KIOSKSMAPPLANTS: "Kiosks",
      ENTERYOUREMAILTORESETYOURPASSWORD:
        "Escreva o seu email para restaurar a sua palavra-passe",
      SUBMIT: "Submeter",
      CANCEL: "Cancelar",
      SIGNIN: "Entrar",
      EMAILIDISREQUIRED: "Id de email é obrigatório",
      PASSWORDISREQUIRED: "Senha requerida",
      INVALIDEMAILID: "Email inválido",
      THELOGINDETAILSAREINCORRECT: "Credênciais de login incorretas",
      COMPANYNAMEISREQUIRED: "Nome da empresa é obrigatório",
      NAMEISREQUIRED: "Nome é obrigatório",
      PHONENUMBERISREQUIRED: "Número de telefone obrigatório",
      COUNTRYISREQUIRED: "O país é obrigatório",
      EMAILISREQUIRED: "Id de email é obrigatório",
      CONFIRMPASSWORDISREQUIRED: "A senha de conformidade é necessária",
      ACCEPTTSCSISREQUIRED: "Aceitar Ts & Cs é obrigatório",
    },

    CALENDAR: {
      TODAY: "Hoje",
      MEETINGROOMS: "Salas de Reunião",
      DESK: "Mesa",
      PARKINGSEATS: "Lugares de Estacionamento",
      MONTH: "Mês",
      WEEK: "Semana",
      DAY: "Dia",
      SUNDAY: "Domigo",
      MONDAY: "Segunda-feira",
      TUESDAY: "terça",
      WEDNESDAY: "quarta-feira",
      THURSDAY: "quinta-feira",
      FRIDAY: "sexta-feira",
      SATURDAY: "sábado",
      ALLMEETINGROOMS: "Todas as salas de reunião",
      ALLDESK: "Todas as mesas",
      ALLPARKINGSEATS: "Todos os parques de estacionamento",
      CHARGINGCAR: "Posto de Carregamento",
      ALLCHARGINGCAR: "Todos os postos de carregamento",
      YOUWANTTOENDTHEBOOKING: "Quer terminar a reserva?",
    },

    MONTH: {
      JANUARY: "de Janeiro,",
      FEBRUARY: "de Fevereiro,",
      MARCH: "de Março,",
      APRIL: "de Abril,",
      MAY: " de Maio,",
      JUNE: "de Junho,",
      JULY: "de Julho,",
      AUGUST: "de Agosto,",
      SEPTEMBER: "de Setembro, ",
      OCTOBER: "de Outubro,",
      NOVEMBER: "de Novembro,",
      DECEMBER: "de Dezembro, ",
    },
    REPORT: {
      LOCATION: "Localização",
      ROOMS: "Salas",
      SERVICES: "Equipamentos",
      NOSERVICEDATAAVAILABLE: "Sem dados de serviço disponíveis",
      LOCATIONISREQUIRED: "A localização é obrigatória",
      ROOMSISREQUIRED: "Salas são obrigatórias",
      SELECT: "--Selecionar--",
      DAMAGED: "Tem a certeza que o equipamento está danificado?",
      CONFIRM: "Confirmar",
      FIX: "Tem a certeza que o equipamento foi arranjado?",
      OBSERVATION: "Observações",
      OBSERVATIONPLACEHOLDER: "Inserir Observações",
      BUILDING: "Edifício",
      FLOOR: "Piso",
      SELECTBUILDING: "Selecione Edificio",
      SELECTFLOOR: "Selecione Piso",
    },
    ROOMSETTINGSMATTABLE: {
      NAME: "Nome",
      LOCATIONS: "Localizações",
      FILTER: "Filtro",
      ACTION: "Ação",
      ADD: "Adicionar",
      MEETINGROOM: " Salas de Reunião",
      DESKS: "Mesas",
      PARKINGSEATS: "Lugares de Estacionamento",
      CHARGINGCAR: "Posto de Carregamento",
      KIOSKS: "Kiosks",
      VIEWPOINT: "Viewpoints",
      DISPLAY: "Displays",
      OPENSPACE: "Open Space",
      SPACE: "Plantas",
      FLOORNO: "Piso",
      CAR: "Carros",
      CROP: "Editar Espaço",
      EDIT: "Editar planta",
      AVAILABLE: "Disponível",
      EDITMEETINGROOMTITLE: "Editar Sala",
      EDITDESKTITLE: "Editar Mesa",
      EDITPARKINGSEARTITLE: "Editar Lugares de Estacionamento",
      EDITCHARGINGCARTITLE: "Editar Posto de Carregamento",
      DELETECHARGINGCARTITLE: "Apagar Carregamento de Veículo",
      EDITKIOSKTITLE: "Editar Kiosk",
      EDITCARTITLE: "Editar Carro",
    },

    ROOMSETTINGSDISPLAYMATTABLE: {
      DISPLAYID: "Display ID",
      SERIALNO: "Serial No",
      TYPES: "Tipos",
      FILTER: "Filtro",
      ROOMS: "Salas",
      DESKNAME: "Secretatias Nome",
      LOCATIONS: "Localizações",
      ACTION: "Ação",
      DISPLAYNAME: "Nome do Display",
      ADD: "Adicionar",
      ROOMDESKNAME: "Nome da Sala",
      EDITDISPLAYTITLE: "Editar Display",
      DELETEDISPLAY: "Apagar Tela",
    },

    ROOMSETTINGSMEETINGROOMFORM: {
      EDITMEETINGROOM: "Editar Sala de Reunião  ",
      NAME: "Nome",
      ENTERNAME: "Insertar Nome",
      ROOMNAMEREQUIRED: "Sala de Reunião Nome é obrigatório",
      CARNAMEISREQUIRED: " Nome do Carro  é obrigatório",
      EDITCAR: "Editar Carro ",
      CAPACITY: "Capacidade",
      PARKING: "Estacionamento",
      ENTERPARKING: "Introduzir  Estacionamento",
      KILOMETERS: "Kilometros",
      ENTERKILOMETERS: "Introduzir Kilometros",
      KILOMETERS1: "Kilometros :",
      FUEL1: "Depósito :",
      FUEL: "Depósito",
      SELECTFUEL: "--Selecione Depósito--",
      RESERVE: "Reserva",
      TANK1: "1/4 Depósito",
      TANK2: "Meio Depósito",
      TANK3: "3/4 Depósito",
      TANK4: "Depósito Cheio",

      NOTES: "Notas",

      LOCATION: "Localização",
      HOURLYPRICE: "Preço por hora",
      FLOOR: "Andar",
      CAPACITY1: "Lotação",

      ENTERFLOOR: "Insertar Andar",
      ENTERCAPACITY: "Insertar Lotação",
      SELECTDISPLAYNAME: "Selecione o Nome do Display",
      INTEGRATIONTYPE: "Tipo de Integração",
      RESOURCEMAIL: "Email do Recurso",
      PASSWORD: "Senha",
      ENTERRESOURCEEMAIL: "Insertar Email do Recurso",
      SELECTLOCATION: "--Selecionar localização--",
      DAILYPRICE: "Preço por dia",
      WEEKLYPRICE: "Preço por semana",
      MONTHLYPRICE: "Preço por mês",
      CREATEQRCODE: "Criar Código QR",
      SUBMIT: "Submeter",
      UPDATEDSUCESSFULLY: "Atualizado com sucesso",
      WORKINGDAYS: "Dias de Trabalho",
      SELECTTYPE: "Selecionar Tipo",
      STANDARD: "Standard",
      IMAGE: "Imagem",
      PROVIDERINFORMATION: "informações do Fornecedor",
      ENTERPROVIDERINFORMATION: "Insertar informações do Fornecedor ",
      EQUIPMENTS: "Equipamentos",
      PREMIUM: "Autorização",
      DESCRIPTION: "Descrição",
      CANCEL: "Cancelar",
      DISPLAYNAME: "Nome do Display",
      BACK: "Voltar",
      PREMIUMUSER: "Utilizador Premium",
      ENTERPASSWORD: "Inserir Senha",
      ENTERDESCRIPTION: "Inserir Descrição",

      INSURANCECOMPANY: "Companhia de seguros",
      INSURANCEPOLICY: "Apólice do seguro",
      VALIDUNTIL: "Válido até",
      TRAVELASSISTANCECONTACT: "Assistência em viagem",
      MODALITY: "Modalidade",
      PURCHASE: "Comprado",
      RENTING: "Renting",
      UNTIL: "até",
      MAINTENANCE: "Manutenção",

      DOWNLOADCSVFILE: "Descarregar Ficheiro CSV",
      CLOSE: "Fechar",
      SAVECHANGES: "Guardar Plterações",

      NAME1: "Nome :",
      DESCRIPTION1: "Descrição :",
      LASTMAINTENANCE1: "Ultima manutenção :",
      LASTMAINTENANCE: "Ultima manutenção",
      CONFIGURE: "Configurar Planta",
      PREMIUMUSERPLACHOLDER: "Selecionar Utilizador Premium",
      CREATEDSUCCESSFULLY:"Criado com Sucesso",
    },

    ROOMSETTINGSDESKFORM: {
      EDITDESK: "Editar Mesas",
      NAME: "Nome",
      DESKNAMEREQUIRED: " Mesa Nome é obrigatório",
      LOCATION: "Localização",
      HOURLYPRICE: "Preço por hora",
      FLOOR: "Andar",
      INTEGRATIONTYPE: "Tipo de Integração",
      DAILYPRICE: "Preço por dia",
      WEEKLYPRICE: "Preço por semana",
      MONTHLYPRICE: "Preço por mês",
      CREATEQRCODE: "Criar Código QR",
      SUBMIT: "Submeter",
      UPDATEDSUCESSFULLY: "Atualizado com sucesso",
      WORKINGDAYS: "Dias de Trabalho",
      SELECTEDTYPE: "Selecionar tipo",
      STANDARD: "Padrão",
      IMAGE: "Imagem",
      EQUIPMENTS: "Equipamentos",
      PREMIUM: "Autorização",
      DESCRIPTION: "Descrição",
      CANCEL: "Cancelar",
      OPENSPACENAME: "Nome do Open Space",
      SELECTOPENSPACE: "--Selecionar Nome do Open Space--",
      BACK: "Voltar",
      MAXIMUMSEATS: "Limite de Lugares",
      DISPLAYNAME: "Nome do Display",
      PREMIUMUSER: "Utilizador Premium",
    },

    ROOMSETTINGSOPENSPACEMATTABLE: {
      OPENSPACENAME: "Nome do Open Space",
      FLOOR: "Andar",
      ACTIVEDESKS: "Active Secretatias",
      TOTALDESKS: "Total Secretatias",
      ACTION: "Ação",
      ADD: "Adicionar",
    },

    OPENSPACEADDMODAL: {
      ADDOPENSPACE: "Adicionar Open Space",
      EDITOPENSPACE: "Editar Open Space",
      OPENSPACENAME: "Nome do Open Space",
      ENTEROPENSPACENAME: "Colocar nome do Open space",
      OPENSPACENAMEREQUIRED: " Nome do Open Space é Obrigatório",
      FLOOR: "Andar",
      TOTALCAPACITY: "Capacidade Total",
      ENTERTOTALCAPACITY: "Colocar a capacidade total",
      PANDEMICSITUATION: "Situação Pandémica",
      BOOKINGCAPACITY: "Capacidade de Reserva",
      CLOSE: "Fechar",
      SAVE: "Guardar",
      UPDATE: "Atualizar",
    },

    ROOMSETTINGSPARKINGSEATFORM: {
      EDITCHARGINGCAR: "Editar Posto de Carregamento",
      CHARGINGCAR: "Posto de Carregamento",
      EDITPARKINGSEAT: "Editar Lugares de Estacionamento",
      PARKINGSEATNUMBER: "Nº do Lugar de Estacionamento",
      ENTERPARKINGSEAT: "Inserir Nº do Lugar de Estacionamento",
      PARKINGSEATNUMBERISREQUIRED:
        "Nº do Lugar de Estacionamento é obrigatório",
      FLOOR: "Andar",
      USERMOBILENUMBER: "Contacto telemóvel",
      ENTERMOBILENUMBER: "Inserir Contacto telemóvel",
      ENTEREMAIL: "Inserir Email",
      CARBRAND: "Marca do Carro",
      ENTERCARBRAND: "Inserir Marca do Carro",
      PLATE: "Matrícula",
      ENTERPLATE: "Inserir Matrícula",
      MODEL: "Modelo",
      ENTERMODEL: "Inserir Modelo",
      PERMANENT: "Permanente",
      LOCATION: "Localização",
      SUBMIT: "Submeter",
      CANCEL: "Cancelar",
      FROM: "Disponível de",
      TO: "até",
      BACK: "Voltar",
      USEREMAIL: "Email do utilizador",
    },

    ROOMSETTINGSKIOSKFORM: {
      EDITKIOSK: "Editar Kiosk",
      NAME: "Nome",
      ENTERKIOSKNAME: "Inserir Kiosk Nome",
      KIOSKNAMEISREQUIRED: "Kiosk Nome é obrigatório",
      LOCATION: "Localização",
      FLOOR: "Andar",
      ROOM: "Sala",
      DESK: "Mesa",
      LOGOUPLOADFILE: "Carregar Logotipo",
      CREATEQRCODE: "Criar Código QR",
      SUBMIT: "Submeter",
      CANCEL: "Cancelar",
      BACK: "Voltar",
      DESKERRORMSG: "Selecionar pelo menos uma Mesa",
      ROOMERRORMSG: "Selecionar pelo menos uma Sala",
      SERVICEERRORMSG: "Selecionar pelo menos uma Serviço",
    },

    ROOMSETTINGVIEWPOINTSFORM: {
      EDIDVIEWPOINTS: "Editar Viewpoints",
      NAME: "Nome",
      ENTERVIEWPOINTSNAME: "Inserir Viewpoints Nome",
      VIEWPOINTSNAMEISREQUIRED: "  ViewPoints Nome é obrigatório",
      LOCATION: "Localização",
      LOGOUPLOADFILE: "Carregar Logotipo",
      SUBMIT: "Submeter",
      CANCEL: "Cancelar",
      BACK: "Voltar",
      SERVICES: "Serviços",
    },
    DISPLAYMODALFORM: {
      ADDDISPLAY: "Adicionar Display",
      EDITDISPLAY: "Editar Display",
      DISPLAYID: "Display ID",
      DISPLAYIDISREQUIRED: "Display Id é obrigatório",
      SERIALNO: "Número de Serie",
      SELECTMEETINGROOM: "--Selecionar Salas de Reunião--",
      SELECTDESK: "--Selecionar Mesa--",
      SELECTCHARGINGCAR: "--Select Charging Car--",
      OS: "OS",
      TYPES: "Tipo",
      ROOMNAME: "Sala Nome",
      LOCATION: "Localização",
      DESKNAME: "Mesa Nome",
      SAVE: "Guardar",
      DESK: "Mesa",
      MEETINGROOM: "Sala de Reunião",
      PARKINGSEAT: "Lugar de Estacionamento",
      ADD: "Adicionar",
      CHARGINGCAR: "Posto de Carregamento",
      VISITKIOSK: "Visit Kiosk",
      IMAGE: "Imagem",
    },
    LOCATIONCONFIGURATION: {
      ADDNEWLOCATION: "Adicionar novo local",
      UPDATELOCATION: "Atualizar Localização",
      SELECTCOUNTRY: "Selecionar País",
      ENTERLOCATION: "Inserir Localização ",
      SELECTTIMEZONE: "Selecionar Fuso Horário",
      CHECKOUT: "Enviar um email após o check-out",
      ADDRESS: "Morada",
      SAVE: "Guardar",
      DELETE: "Apagar",
      CANCEL: "Cancelar",
      OR: "(ou)",
      LOCATIONCONFIGURATION: "Configuração de Localização",
      LOGOCONFIGURATION: "Configuração do Logotipo",
      ENABLELOGOCHANGES: "Alterar Logotipo",
      UPLOADLOGO: "Fazer upload do logotipo",
      URL: "URL",
      ALL: "Todos",
      REPORTING: "Reportar",
      EMAIL: "Email",
      MEETINGROOM: "Sala de Reuniões",
      DESK: "Mesas",
      CARS: "Carros",
      DISPLAYCHECKIN: "Check-In no Display",
      GENERATEPINCODE: "Gerar Código PIN ",
      BOOKONDISPLAY: "Marcar no Display",
      NETWORKONDISPLAY: "Observações",
      SELECTTIME: "Selecionar Tempo",
      SELECTPREMIUMUSER: "Selecione Utilizador Premium",
      PARKINGSEATS: "Lugares de Estacionamento ",
      PREMIUM: "Autorização",
      PARKINGSEATSEMAILS: "Emails de Lugares de estacionamento",
      CAREMAILS: "Emails Carros",
      LABOURHOURS: "Hórario Laboral",
      SELECTFROMTIME: "Hora de Entrada",
      HOUR: "Hora",
      SELECTENDTIME: "Hora de Saída",
      CLEANING: "Limpeza",
      CLEANINGTIME: "Emails de Limpeza",
      CLEANINGEMAILS: "Emails Limpeza",
      MOBILEEQUIPMENT: "Equipamento Móvel",
      MOBILEEQUIPMENTNAME: "Nome do Equipamento Móvel",
      EMAILS: "Emails",
      ACTION: "Ação",
      SEARCHHERE: "Procure aqui",
      CATERING: "Catering",
      CATERINGNAME: "Nome do Catering",
      ITSUPPORTSERVICE: "Suporte Informático ",
      SPECIALSERVICES: "Serviços Especiais",
      ADDSPECIALSERVICE: "Adicionar Serviço Especial",
      ADD: "Adicionar",
      ADDNEWMOBILEEQUIPMENT: "Adicionar Equipamento Móvel ",
      EDITMOBILEEQUIPMENT: "Editar Equipamento Móvel",
      DELETEMOBILEEQUIPMENT: "Apagar Equipamento Móvel",
      MOBILEEQUIPMENTEMAIL: "Email do Equipamento Móvel ",
      ADDNEWCATERING: "Adicionar Catering",
      CATERINGEMAILS: "Email do Catering",
      EDITCATERING: "Editar Catering",
      DELETECATERING: "Apagar Catering",
      ADDNEWITSUPPORT: "Adicionar Suporte Informático",
      ITSUPPORTNAME: "Nome do Suporte Informático",
      ITSUPPORTEMAILS: "Email do Suporte Informático  ",
      EDITSPECIALSERVICE: "Editar Serviço Especial ",
      DELETESPECIALSERVICE: "Apagar Serviços Especiais",
      SPECIALSERVICENAME: "Nome do Serviço Especial ",
      SPECIALSERVICEEMAIL: "Email do Serviço Especial",
      ADDNEWSPECIALSERVICE: "Adicionar Serviços Especial",
      ADDSPECIALSSERVICEEMAILS: "Adicionar Serviços especiais Emails",
      NAME: "Nome",
      PASSWORD: "Senha ",
      BACK: "Voltar",
      ADDNEWLANGUAGE: "Adicionar novo Linguagem",
      LANGUAGE: "Linguagem",
      EDIT: " Editar",
      UPDATELANGUAGE: "Atualizar Linguagem",
      EDITITSUPPORTSERVICE: "Editar Suporte Informático ",
      DELETEITSUPPORTSERVICE: "Apagar Suporte Informático",
      INFORMREQUESTERABOUTSTART: "Informar o requisitante do inicio ",
      INFORMREQUESTERABOUTEND: "Informar o requisitante do final",
      EQUIPMENT: "Equipamento",
      CATERINGBOOKINGRESTRICT: "Restrição de Pedidos com menos de 24 Horas",
      SPECIALSERVICEGBOOKINGRESTRICT:
        "Restrição de Pedidos com menos de 24 Horas",
      ITSUPPORTRESTRICT: "Restrição de Pedidos com menos de 24 Horas",
      MOBILEEQUIPMENTRESTRICT: "Restrição de Pedidos com menos de 24 Horas",
      ENDBOOKINGEMAILTIME: "Informar do Final",
      HOURS: "Hórario",
      ENDONDISPLAY: "Terminar no Display",
      EXTENDONDISPLAY: "Estender no Display",
      BUILDING: "Edifício",
      BUILDINGNAME: "Building Name",
      BUILDINGNAMEREQUIIRED: "Nome do Edifício é obrigatório",
      ADDBUILDING: "Add Building",
      EDITBUILDING: "Edit Building",
      DELETEMSG: "Tem a certeza de que deseja excluir permanentemente?",
      FLOOR: "Piso",
      FLOORNAME: "Piso Nº",
      // FLOORNAME: 'Nome do Piso',
      FLOORNAMEREQUIRED: "Nome do Piso é obrigatório",
      ADDFLOOR: "Add Floor",
      EDITFLOOR: "Edit Floor",
      BUILDINGCONFIGURATION: "Definições de Edifício",
      CHARGINGCAREMAIL: "Emails de Posto de Carregamento",
      CHARGINGCARSETTING: "Definições Posto de Carregamento:",
      NORMALCHECKIN: "Normal Check In"
    },

    ADDCONFIGUREADMIN: {
      COMPANYNAME: "Nome da Empresa",
      ENTERCOMPANYNAME: "Introduzir Nome da Empresa",
      COMPANYNAMEISREQUIRED: "Nome da Empresa é obrigatório",
      CONTACTNAME: "Nome do Contacto",
      ENTERCONTACTNAME: "Introduzir Nome do Contacto",
      CONTACTNAMEISREQUIRED: "Nome do Contacto é obrigatório",
      PHONENUMBER: "Número Telefónico",
      ENTERPHONENUMBER: "Introduzir Número Telefónico",
      COUNTRYISREQUIRED: "País é obrigatório",
      RESELLER: "Parceiro",
      ENTERRESELLER: "Introduzir Parceiro",
      ZELOCAR: "Zelo carro",
      ZELOCAR1: "Laia carro",
      COUNTRY: "País",
      EMAILTOREGISTRATION: "Email de Registo",
      ENTEREMAILTOREGISTER: "Introduzir Email de Registo",
      TYPEOFACCOUNT: "Tipo de Conta",
      TYPEOFACCOUNTISREQUIRED: "Tipo de Conta é obrigatório",
      NUMBEROFROOMS: "Número de Salas",
      ENTERNOOFROOMS: "Introduzir Número de Salas",
      NUMBEROFROOMSDISPLAYS: "Número de Displays nas Salas",
      ENTERNUMBEROFROOMSDISPLAYS: "Introduzir Número de Displays nas Salas",
      NUMBEROFDESKS: "Número de Mesas",
      NUMBEROFDESKSDISPLAYS: "Número de Displays nas Mesas ",
      NUMBEROFPARKINGSPACES: "Número de Lugares de Estacionamento",
      NUMBEROFSERVICESVIEWPOINTS: "Número de Viewpoints",
      NUMBEROFKIOSKS: "Número de Kiosks",
      ACCOUNTID: "ID da Conta",
      VALIDFROM: "Válido de",
      VALIDFROMISREQUIRED: " Válido de  é obrigatório",
      VALIDTO: "Válido até",
      VALIDTOISREQUIRED: "Válido até  é obrigatório",
      CONTACTSUPPORT: "Contactar o Suporte",
      MESSAGE: "Mensagem",
      BACK: "Voltar",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      PASSWORD: "Senha",
      ONLINEPAYMENT: "Pagamento online",
      MRCARS: "MrCars",
      MRVISITS: "MrVisits",
      ADDCONFIGURECUSTOMERADMIN: "Adicionar Configurar Admin do Cliente",
      EDITCONFIGURECUSTOMERADMIN: "Editar Configurar Admin do Cliente",
      NUMBEROFCARS: "Número de carros",
    },
    DASHBOARDS: {
      FROM: "de",
      TO: "a",
      DOWNLOADCSVFILE: "Descarregar Ficheiro CSV ",
      DOWNLOAD: "Descarregar",
      CUSTOMERADMINS: "Administrador do Cliente",
      ACTIVE: "Ativas ",
      DEMOTRIALACTIVE: "Demo/Teste (Activo)",
      NEW: "Nova",
      LEAVING: "Saíndo",
      SHOWMORE: "Ver Mais",
      NUMBEROFROOMS: "Número de Salas",
      NUMBEROFDISPLAYS: "Número de Displays",
      NUMBEROFDESKS: "Número de Mesas",
      NUMBEROFDESKSDISPLAYS: "Número de Displays nas Mesas ",
      NUMBEROFPARKINGSEATS: "Número de Lugares de Estacionamento  ",
      NUMBEROFKIOSKS: "Número de Secretárias",
      NUMBEROFSERVICESVIEWPOINTS: "Número de Viewpoints",
      NUMBEROFONLINEPAYMENT: "Número de Pagamentos Online",
      BOOKINGS: "Marcações",
      NUMBEROFBOOKINGSDAY: "Número de Marcações por / Dia",
      NUMBEROFBOOKINGSMONTH: "Número de Marcações por / Mês",
      NUMBEROFBOOKINGYEAR: "Número de Marcações por / Ano",
      UPCOMINGRENEWAL: "Próxima Renovação",
      RECENTACTIVITIES: "Actividades Recentes",
      NOUPCOMINGRENEWAL: "No Upcoming Renewal",
      NORECENTACTIVITIES: "Sem Actividades Recentes",
    },

    CONFIGURECUSTOMERADMIN: {
      COMPANYNAME: "Nome da Empresa",
      EMAIL: "Email",
      COUNTRY: "País",
      ACCOUNTTYPE: "Conta tipo",
      VALIDTODATE: "Válido até Data",
      ACTION: "Ação",
      ADD: "Adicionar",
    },

    MYPROFILE: {
      MYPROFILE: "O meu perfil",
      CHANGEPASSWORD: "Mudar Palavra-Passe",
      CURRENTPASSWORD: "Palavra-passe Ptual",
      NEWPASSWORD: "Nova Palavra-Passe",
      VERIFYPASSWORD: "Verificar Palavra-Passe",
      CONFIRMPASSWORD: "Confirmar Palavra-Passe",
      SAVECHANGES: "Guardar Plterações",
      SIGNOUT: "Sair/Log-out",
      BACK: "Voltar",
      CANCEL: "Cancelar",
      NAME: "Nome",
      EMAIL: "Email ",
      COUNTRY: "País",
      LOCATION: "Localização",
      SAVE: "Guardar",
      BUILDING: "Edifício",
      FLOOR: "Piso",
      LANGUAGE: "Linguagem"
    },

    ENDUSERDASHBOARD: {
      ROOMS: "Salas",
      DESKS: "Mesas",
      PARKINGSEATS: "Lugares de Estacionamento",
      ROOMDESKBOOKINGREQUESTS: "Pedidos de Marcação Pendentes",
      TYPE: "Tipo",
      RESOURCE: "Recurso",
      REQUESTERNAME: "Requisitante",
      STARTTIME: "Hora de Início",
      ENDTIME: "Hora de Fim",
      ACTION: "Ação",
      NODATAFOUND: "No Date Found",
      CARS: "Carros",
    },

    SIDENAVBAR: {
      MYPROFILE: "O meu perfil",
      CHANGEPASSWORD: "Mudar Palavra-Passe",
      CURRENTPASSWORD: "Palavra-Passe Atual",
      NEWPASSWORD: "Nova Palavra-Passe",
      VERIFYPASSWORD: "Verificar Palavra-Passe",
      CONFIRMPASSWORD: "Confirmar Palavra-Passe",
      SAVECHANGES: "Guardar Alterações",
      SIGNOUT: "Sair",
      USERPROFILE: "Meu Perfil",
      HI: "Olá,",
    },

    SERVICEVIEWPOINTS: {
      NAME: "Nome",
      LOCATION: "Localização",
      ACTION: "Ação",
      FILTER: "Filtro",
      BACK: "Voltar",
    },
    SPACESERVICE: {
      SPACESERVICEADD: "Add Space",
      NAME: "Nome",
      ADDRESS: "Morada",
      LOCATION: "Localização",
      BUILDINGNAME: "Nome do edifício",
      FLOORNO: "Floor No",
      IMAGE: "Imagem",
      BACK: "Voltar",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      ACTION: "Action",
      NO: "No.",
    },
    SPACE: {
      SPACELIST: "Selecionar Planta",
      SELECTSPACE: "--Selecionar Planta--",
      STATUS: "Próximas Marcações",
    },
    // Space Edit Crop add function
    CROPSERVICE: {
      CONFIGURERESOURCE: "Configure Resource",
      AREANAME: "Area Name",
      RESOURCETYPE: "Resoure type",
      RESOURCE: "Resource",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      CROP: "Espaço",
      DELETE: "Apagar",
      ZOOM: "Ampliar",
      BACK: "Voltar",
    },
    COMMON: {
      AREYOUSURE: "Tem a certeza?",
      SHOWMORE: "Mais Opções",
      SHOWLESS: "Mostrar Menos",
      YOUWANTTODELETE: "Você quer excluir!"
    },

    VISITSETTING: {
      VISITSSETTINGS: "Configurações das Visitas",
      VISITORS: "Visitantes",
      SAVE: "Guardar",
      VISITS: "Visitas",
      MANDATORYFIELDS: "Campos Obrigatórios",
      RGPDSAFETYRULES: "RGPD e Regras de Segurança",
      ENABLERGPDANDSAFETYRULES: "Habilitar RGPD e Regras de Segurança",
      RGPDCONDTION: "Condições RGPD",
      SAFETYRULES: "Regras de Segurança",
      CARDS: "Cartões",
      ENABLECARD: "Habilitar Cartão",
      ADDCARD: "Adicionar Cartão",
      CARDNO: "Número e Cartão",
      CARDNUMBER: "Número e Cartão",
      ADDCARDNUMBER:"Adicionar Número do Cartão",
      ACTION:"Ação",
      CLOSE:"Fechar",
      UPDATECARD:"Atualizar Cartão",
      CARD:"Cartão",
      DELETECARD:"excluir cartão",
      CHECKINCOUNT:"Check-in Activos",
      PARTIALCHECKOUTCOUNT:"Contagem de Check-Out Parciais",
      ADDVISIT:"Adicionar Visita",
      EDITVISIT:"Editar Visita",
      SELECTDATE :"Selecionar Data",
      DATE:"Data",
      FILTER:"Filtrar",
      ADDORDER:"Registar Entrega",
      AREYOUSURETOREMOVECARD:"Confirma a entrega do Cartão?",
      IACCEPTEDTHECONDITION:"Aceito as Condições RGPD",
      IACCEPTEDTHERULE:"Aceito as Regras de Segurança",
      DELETEPERSONALDATA:"Eliminar dados pessoais",
      DOYOUCONFIRM:"Confirme aqui, caso pretenda remover os seus dados da nossa base de dados",

      VISITOR: {
        NAME: "Nome",
        GROUP: "Grupo",
        COMPANY:"Empresa",
        DEPTFUNCTION: "Departamento/Função",
        EMAIL: "Email",
        CONTACT: "Contacto",
        FOODRESTRICTIONS: "Restrições Alimentares",
        REMOVERGPDDATA :"Remover Dados RGPD",
        OBSERVATION: "Observações",
        PLACEHOLDER:{
          ENTERNAME:"Inserir Nome",
          SELECT:"Selecionar",
          INTEERNAL:"Interno",
          EXTERNAL:"Externo",
          ENTERCOMPANY :"Inserir Empresa",
          ENTERDEPTFUNCTION:"Inserir Dep/Função",
          ENTEREMAIL:"Inserir Email",
          ENTERCONTACT:"Inserir Nº Telemóvel",
          ENTERFOODRESTICTIONS:"Inserir Restrições Alimentares",
          ENTEROBSERVATION :"Inserir Observações",
         
        },
        REQUIRED:{
          NAMEISREQUIRED:"Name is required",
          GROUPISREQUIRED:"Group is required",
          COMPANYISREQUIRED:"Company is required",
          DEPTFUNCTIONISREQUIRED:"Dept/Function is required",
          EmailIDISREQUIRED:"Email is required",
          INVALIDEMAILID:" Invalid Email id",
          EMAILIDTOLONG:"Email id should contain more than 1 less than 254 characters",
          CONTACTISREQUIRED:"Contact is required",
          FOODISREQUIRED:"Food Restrictions is required",
          OBSERVATIONISREQUIRED:"Observations is required",
        }
        // REQUIRED:{
        //   NAMEISREQUIRED:"Nome é obrigatório",
        //   GROUPISREQUIRED:"Grupo é obrigatório",
        //   COMPANYISREQUIRED:"Empresa é obrigatória",
        //   DEPTFUNCTIONISREQUIRED:"É necessário o Departamento/Função",
        //   EmailIDISREQUIRED:"É necessário o email",
        //   INVALIDEMAILID:"  Email inválido ",
        //   EMAILIDTOLONG:"O email deve conter mais de 1 e menos de 254 caracteres",
        //   CONTACTISREQUIRED:"O contato é obrigatório",
        //   FOODISREQUIRED:" Restrições alimentares são obrigatórias",
        //   OBSERVATIONISREQUIRED:"É obrigatório observações",
        // }
      },
      VISIT: {
        LOCATION: "Localização",
        BUILDING: "Edifício",
        PURPOSE: "Propósito",
        HOST: "Visitado",
        HOSTEMAIL: "Email do Visitado",
        ARRIVAL: "Chegada",
        DEPARTURE: "Partida",
        USERS : "Utilizadores",
        HOTELNAME: "Nome do Hotel",
        RESERVATIONNO: "Número de Reserva",
        OBSERVATION: "Observações",
        FLIGHTNO: "Número de Voos",
        FLIGHT:"Voos",
        CHECKIN:"Check-In",
        CHECKOUT:"Check-Out",
        ASSIGNCARD:"Atribuir Cartão",
        REMOVECARD:"Remover Cartão",
        VISITINFO:"Informações do Visitante",
        HOTEL:"Hotel",
        ADDVISITOR:"Adicionar Visitante",
        EDITVISITOR:"Editar Visitante",
        VIEWCHECKINCHECKOUT:"Visualizar - Check-in e Check-out",
        STATUS:"Estado",
        PLACEHOLDER:{
          ADDVISITOR:"Adicionar Visitantes",
          SELECTALL:"Selecionar Todos",
          SEARCH:"Filtrar",
          SELECTLOCATION:"Selecionar Localização",
          LOCATIONISREQUIRED:"Localização Obrigatória",
          SELECTBUILDING :"Selecionar Edifício",
          SELECTPURPOSE:"Selecionar Motivo",
          ENTERHOSTEAIL:"Inserir Email do Visitado", 
        },
        PARTIALCHECKIN: "Check-In Parcial",
        PARTIALCHECKOUT: "Check-Out Parcial"
      },
      ORDER:{
        NAME: "Nome",
        VOLUMNSANDPACKAGES:"Volumes/Pacotes",
        CARRIER:"Transportadora",
        NOTE:"Nota",
        COLLECTED:"Recolhido",
        COLLECT:"Confirmar",
        COLLECTEDNOTES:"Notas coletadas",
        ORDERCOLLECTED:"Pedido coletadas",
        NOTES: "Notas",
        ENTERYOURNOTES:"Introduza nota:",
        TYPE:"Escreva aqui a sua nota...",
        DOYOUWANTTOADDNOTES:"Pretende adicionar alguma nota à entrega?",
        PLACEHOLDER:{
          SELECT:"Selecionar",
          SEARCH:"Filtrar",
          USERISREQUIRED:"Utilizador Obrigatório",
          ENTERVOLUMNSPACKAGES:"Introduzir nº de Volumes / Pacotes",
          VOLUMNPACKAGESREQUIRED:"Volumes / Pacotes Obrigatório",
          ENTERNOTE:"Inserir Nota",
        }
      }

    }
  },
};
